import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BugReportService } from './bug-report.service';
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Editor, Toolbar } from 'ngx-editor';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { downloadBase64Image } from '../../../@core/utils/download-image';
import { DateNow } from '../../../@core/constants/time.defaults';
import { FormsHelperService } from '../../../@core/services/helpers/forms-helper.service';
import { ClickupApiService } from '../../../@core/clickup-api.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-bug-report',
  templateUrl: './bug-report.component.html',
  standalone: false,
})
export class BugReportComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('bugcanvas') bugCanvasElement: ElementRef<HTMLCanvasElement>;
  @ViewChild('bugContainer') bugContainerElement: ElementRef<HTMLDivElement>;

  public loading$ = new Subject();

  public bugForm: UntypedFormGroup;
  public bugSeverties = [
    'Critical Malfunction',
    'Minor Bug',
    'Feature Request',
    'Comment',
  ];
  public showCanvas = false;
  editor: Editor;
  html = '';
  bugSeverity = '';
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['text_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  private soundUrl = 'assets/sounds/camera.mp3';
  private audio = new Audio(this.soundUrl);
  public loading = false;
  public description = new FormControl('');
  public imagePath: any;

  constructor(
    private bugSrv: BugReportService,
    private modal: NzModalRef,
    private fb: UntypedFormBuilder,
    private _formHelpers: FormsHelperService,
    private ticketServ: ClickupApiService,
    private _notifications: NzNotificationService
  ) {}

  ngOnInit(): void {
    this.loading$.next(false);
    this.editor = new Editor();
    this.bugForm = this.fb.group({
      title: ['', Validators.required],
      reason: ['', Validators.required],
      description: ['', Validators.required],
    });
  }
  ngAfterViewInit(): void {
    this.HackSvgIcons();
  }
  ngOnDestroy(): void {
    this.editor.destroy();
  }

  private async GetSnapshot(): Promise<string> {
    const img = await this.bugSrv.takeSnapshot(
      document.getElementById('dashboard')
    );
    return Promise.resolve(img);
  }

  public async DrawPic() {
    this.loading = true;
    try {
      const img = await this.GetSnapshot();
      this.imagePath = img;
      this.audio.play();
      this.loading = false;
      this.showCanvas = true;
    } catch (error) {
      console.log(error);
    }
  }
  public async submitBug() {
    this.loading$.next(true);
    if (!this.bugForm.valid) {
      this._formHelpers.formChecker(this.bugForm);

      this.loading$.next(false);
      return;
    }
    try {
      await this.ticketServ.createTicket({
        ...this.bugForm.value,
        image: this.imagePath,
      });
      this._notifications.info('Success', 'Suggestion/Report sent to our team');
      this.loading$.next(false);
    } catch (error) {
      this._notifications.error('Error', 'Error creating suggestion');
      console.error(error);
      this.loading$.next(false);
    }
    this.loading$.next(false);
    this.modal.destroy(null);
  }
  private HackSvgIcons() {
    const iconContainers = document.querySelectorAll(
      '.NgxEditor__MenuItem--IconContainer'
    );
    iconContainers.forEach(function (iconContainer) {
      // Create an SVG element with a viewBox of 0 0 25 25 and a width and height of 25px
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('width', '25');
      svg.setAttribute('height', '25');
      svg.setAttribute('viewBox', '0 0 25 25');

      // Wrap every path element with the created SVG element
      const pathElements = iconContainer.querySelectorAll('path');
      pathElements.forEach(function (pathElement) {
        const newPath = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'path'
        );
        newPath.setAttribute('d', pathElement.getAttribute('d')); // Copy the 'd' attribute
        svg.appendChild(newPath);
      });

      // Replace the original path elements with the newly created SVG element
      iconContainer.innerHTML = svg.outerHTML;
    });
  }

  public async downloadImage() {
    const base64 = await this.GetSnapshot();
    downloadBase64Image(base64, `Shiptwin-screenshot-${DateNow()}.png`);
  }
}
